import type { TSetTranslationKeys } from '@crehana/ts-types';

import type es from './localeEs';
import { routesPt } from './routes';

export type TKeys = TSetTranslationKeys<typeof es>;

type TTranslations = { pt: Record<TKeys, string> };

const localeViewPt: TTranslations = {
  pt: {
    ...routesPt.pt,
    ADD_COURSE_DIALOG_SEARCH: 'Pesquisar curso',
    ADD_COURSE_DIALOG_QUIT: 'Remover',
    ADD_COURSE_DIALOG_ADD: 'Adicionar',
    ADD_COURSE_DIALOG_SAVE: 'Salvar alterações',

    STAT_CARD_DESCRIPTION: 'vs semana anterior',

    ROUTE_MARKET_CONFIG: 'Configuração',

    SNACKBAR_DEFAULT_ERROR: 'Ops! ocorreu um erro, tente novamente mais tarde',
    SNACKBAR_DEFAULT_SUCCESS:
      'O relatório está sendo gerado, em breve você receberá um e-mail com o resultado.',
    SNACKBAR_REPORT_EXISTS_ERROR:
      'Já existe um relatório deste tipo em processo de geração. Por favor, aguarde até que termine antes de solicitar um novo.',

    SEARCH_BY_USERS_HINT: 'Pesquisa por usuários',

    HEADER_BACK_BUTTON_VIEW: 'Retornar',

    TOUR_BUTTON_AGAIN: 'Ver novamente',
    TOUR_BUTTON_START: 'Iniciar',
    TOUR_BUTTON_NEXT: 'Próximo',
    TOUR_TITLE_LAST: 'Excelente trabalho!',
    TOUR_DESCRIPTION_LAST:
      'Agora você está pronto para ir. Se quiser reviver esta integração mais tarde, você pode ir para o Guia do administrador. Temos muitos outros recursos para você que podem ajudá-lo a aproveitar as vantagens da plataforma. ',

    ERROR_CASE_TITLE: 'Ops, ocorreu um erro',
    ERROR_CASE_BODY:
      'Por favor, tente novamente mais tarde, ou pressione o botão abaixo para tentar novamente',
    ERROR_CASE_BUTTON: 'Atualizar',

    STUDENT_COUNTER_BEGINNER: 'Iniciante',
    STUDENT_COUNTER_MIDDLE: 'Intermediário',
    STUDENT_COUNTER_ADVANCED: 'Avançado',
    STUDENT_COUNTER_PERSONS: '{{count}} pessoa',
    STUDENT_COUNTER_PERSONS_plural: '{{count}} pessoas',

    FAQ_DIALOG_TITLE: 'Perguntas mais frequentes',
    FAQ_DIALOG_BODY: 'Caso você tenha uma pergunta adicional, escreva para',

    ERROR_MESSAGE_TITLE: 'Ops, algo deu errado',
    ERROR_MESSAGE_SUBTITLE: 'tente novamente mais tarde.',
    ERROR_MESSAGE_BUTTON: 'Tente novamente',

    INBOX_PANEL_BUTTON: 'Ver todas as mensagens',
    INBOX_PANEL_NO_MESSAGES: 'Você ainda não tem mensagens',
    INBOX_PANEL_GO_CHAT: 'Vá para o chat',
    INBOX_PANEL_CHAT: 'Chat com o Mentor',

    INBOX_ITEM_SEND_IMAGE_1: 'Você enviou uma imagem',
    INBOX_ITEM_SEND_IMAGE_2: 'Enviou uma imagem',
    INBOX_ITEM_SEND_FILE_1: 'Você enviou um arquivo',
    INBOX_ITEM_SEND_FILE_2: 'Enviou um arquivo',
    INBOX_ITEM_SEND_CHAT_1: 'Você iniciou uma conversa',
    INBOX_ITEM_SEND_CHAT_2: 'Iniciou uma conversa',
    INBOX_ITEM_SPECIALIZATION: 'Especialização',

    NEWS_TITLE: 'As últimas novidades na Crehana',
    NEWS_TAB_UPDATES: 'Atualizações',
    NEWS_TAB_COURSES: 'Cursos',

    DEFAULT_BUTTON_AGAIN: 'Tentar novamente',
    DEFAULT_LABEL_NEWS:
      'Você vai descobrir em breve todas as novidades que temos para você!',

    NEWS_NOTIFICATIONS_LABEL: 'Notificações',

    DASHBOARD_LIST: 'Meus perfis',
    DASHBOARD_LX: 'Painel do estudante',
    DASHBOARD_LX_SM: 'Estudiante',
    DASHBOARD_LEADER: 'Líder',
    DASHBOARD_ADMIN: 'Admin',

    PROFILE_ACCOUNT: 'Conta',
    PROFILE_PROFESSOR: 'Painel do Professor',
    PROFILE_MENTOR: 'Mentor',
    PROFILE_ADMIN: 'Administrador',
    PROFILE_LEADER: 'Líder',
    PROFILE_MEMBER: 'Colaborador',
    PROFILE_COURSES: 'Meus cursos',
    PROFILE_PROFILE: 'Meu perfil',
    PROFILE_MANAGE_ACCOUNT: 'Configurar conta',
    PROFILE_HELP_CENTER: 'Centro de ajuda',
    PROFILE_PANEL: 'Painel',
    PROFILE_NIGHTSWITCH: 'Modo Noturno',
    PROFILE_CONFIGURATION: 'Configuração',
    PROFILE_MENTORS: 'Mentores',
    PROFILE_LOGOUT: 'Fechar sessão',

    SEARCH_HEADER_HINT_1: 'Pesquisar usuários',
    SEARCH_HEADER_HINT_2: 'ou organizações',
    SEARCH_HEADER_HINT_3: 'ou trilhas',
    SEARCH_HEADER_USERS: 'Usuários',
    SEARCH_HEADER_TRACKS: 'Trilhas',
    SEARCH_HEADER_ORGANIZATIONS: 'Organizações',
    SEARCH_EMPTY_TITLE: 'Nenhum resultado encontrado',
    SEARCH_EMPTY_SUBTITLE: 'Tente palavras-chave mais genéricas',
    SEARCH_ALL_RESULTS: 'Ver todos os resultados',

    DEFAULT_SEARCH_HINT: 'Pesquisar',

    MENU_ROUTE_MY_SHOP: 'Loja',
    MENU_ROUTE_CONTENT: 'Adicionar conteúdo',
    MENU_ROUTE_METRICS_1: 'Estatísticas',
    MENU_ROUTE_METRICS_NEW: 'Análise',
    MENU_ROUTE_ADMIN: 'Gerenciar',
    MENU_ROUTE_PROJECTS: 'Projetos',
    MENU_ROUTE_CERTIFICATES_GALLERY: 'Certificados',
    MENU_ROUTE_KNOWLEDGE_HUB_DOCUMENTS: 'Documentos',
    MENU_ROUTE_KNOWLEDGE_HUB_CATALOG: 'Catálogo',
    MENU_ROUTE_SKILL_IQ: 'Skill XP',
    MENU_ROUTE_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
    MENU_ROUTE_INTEGRATIONS: 'Integrações',
    MENU_ROUTE_CLASSROOM: 'Classrooms',
    MENU_ROUTE_STUDIO: 'Studios',
    MENU_ROUTE_ELEVATE: 'Elevate',
    MENU_ROUTE_ELEVATE_CONTENT: 'Conteúdo',
    MENU_ROUTE_GAMIFICATION: 'Gamificação',
    MENU_ROUTE_CONFIG: 'Configuração',
    MENU_ROUTE_GUIDE: 'Guia do Administrador',
    MENU_ROUTE_METRICS_2: 'Estatísticas',
    MENU_ROUTE_ADMIN_2: 'Gerenciar',
    MENU_ROUTE_TALENT: 'Talent',
    MENU_ROUTE_CONFIG_2: 'Configuração',
    MENU_ROUTE_INDUCTION: 'Integração',
    MENU_ROUTE_FEEDBACK: 'Comentários',
    MENU_ROUTE_REPORTS: 'Relatórios',
    MENU_ROUTE_HELP: 'Suporte',
    MENU_ROUTE_NEW_HELP: 'Ajuda',
    MENU_ROUTE_HANA_AI: 'Crehana AI',
    REPORTS_NESTED_ROUTE_1: 'Publicados',
    REPORTS_NESTED_ROUTE_2: 'Personalizado',
    REPORTS_NESTED_ROUTE_3: 'Programados',
    REPORTS_NESTED_ROUTE_4: 'Programa',

    MENU_LEADER_METRICS: 'Estatísticas',
    MENU_LEADER_PROJECTS: 'Projetos',
    MENU_LEADER_GUIDE: 'Guia do Líder',

    LEADER_METRICS_NESTED_1: 'Geral',
    LEADER_METRICS_NESTED_2: 'Por usuários',

    MENU_ROUTE_CONTENT_1: 'Trilhas de aprendizagem',
    MENU_ROUTE_CONTENT_3: 'Trilhas Ecommerce',
    MENU_ROUTE_CONTENT_2: 'Cursos própios',

    STATISTICS_LEARNING: 'Aprendizagem',
    GENERAL_NESTED_ROUTE_1: 'Geral',
    GENERAL_NESTED_ROUTE_2: 'Por usuários',
    GENERAL_NESTED_ROUTE_3: 'Por trilhas',
    GENERAL_NESTED_ROUTE_4: 'Por cursos',

    ROUTE_MANAGE_NESTED_1: 'Atributos',
    ROUTE_MANAGE_NESTED_2: 'Usuários',
    ROUTE_MANAGE_NESTED_3: 'Por trilhas',
    ROUTE_MANAGE_NESTED_4: 'Equipes',
    ROUTE_MANAGE_NESTED_5: 'Automação',
    ROUTE_MANAGE_NESTED_6: 'Atributos personalizados',
    ROUTE_MANAGE_NESTED_5_1: 'Nova automação',
    ROUTE_MANAGE_NESTED_5_2: 'Editar automação',
    ROUTE_MANAGE_NESTED_5_3: 'Detalhes do usuário',

    ROUTE_CORP_MANAGE_1: 'Por organizações',
    ROUTE_CORP_MANAGE_2: 'Por administradores',

    ROUTE_TALENT_NESTED_1: 'General',
    ROUTE_TALENT_NESTED_2: 'Engagement',
    ROUTE_TALENT_NESTED_3: 'Performance',

    CONFIGURATION_NESTED_1: 'Conta',
    CONFIGURATION_NESTED_2: 'Aparência',
    CONFIGURATION_NESTED_3: 'Comunicação',
    CONFIGURATION_NESTED_4: 'Certificações',

    INTEGRATIONS_NESTED_ROUTE_1: 'Descubre',
    INTEGRATIONS_NESTED_ROUTE_2: 'Minhas integrações',
    INTEGRATIONS_NESTED_ROUTE_3: 'Personalização',
    INTEGRATIONS_NESTED_ROUTE_4: 'Credenciais',

    SKILL_IQ_GENERAL_NESTED_1: 'Geral',
    SKILL_IQ_GENERAL_NESTED_2: 'Por usuários',
    SKILL_IQ_GENERAL_NESTED_3: 'Por trilhas',

    SKILL_XP_EVOLUTION_NESTED_1: 'Liberadas',
    SKILL_XP_EVOLUTION_NESTED_2: 'Resultados',

    REPORTS_NESTED_1: 'Relatórios',
    REPORTS_NESTED_2: 'Relatório personalizado',

    GAMIFICATION_NESTED_1: 'Progresso',
    GAMIFICATION_NESTED_2: 'Recompensas',

    NEW_ROUTE: 'Novo',

    SIDEBAR_TITLE_DARK_MODE: 'Modo noturno',
    SIDEBAR_MENU_TITLE: 'Meu Painel',

    DEFAULT_SEE_DETAIL: 'Ver detalhes',

    NEWS_DIALOG_TYPE: 'NOVO NO PAINEL',
    NEWS_DIALOG_COURSE_TYPE: 'NOVO CURSO',
    NEWS_DIALOG_BTN_DETAIL: 'Ver detalhes',

    HEADER_PREVIEW_DURATION: 'Duração: ',
    HEADER_PREVIEW_LEVEL: 'Nível: ',
    HEADER_PREVIEW_CERTIFICATION_AVAILABLE: 'Certificado',
    HEADER_PREVIEW_CERTIFICATION_UNAVAILABLE: 'Sem certificado',
    HEADER_PREVIEW_ACTIVE: 'Ativo',
    HEADER_PREVIEW_INACTIVE: 'Inativo',
    PREVIEW_VIDEO_TRAILER: 'Assistir ao trailer',
    PREVIEW_VIDEO_OWN_COURSE: 'Curso próprio',

    COURSE_DETAIL_NESTED_ROUTE_GENERAL: 'Geral',
    COURSE_DETAIL_NESTED_ROUTE_PROJECTS: 'Projetos',
    COURSE_DETAIL_NESTED_ROUTE_REVIEWS: 'Comentários',
    COURSE_DETAIL_NESTED_ROUTE_EVALUATIONS: 'Avaliações',
    COURSE_DETAIL_NESTED_ROUTE_REPORT_SURVEY: 'Votação',
    COURSE_DETAIL_NESTED_ROUTE_LIVE_SESSIONS: 'Sessões ao vivo',

    USER_COURSE_DRAWER_TITLE: 'Atribuir curso',
    USER_COURSE_DRAWER_TITLE_2:
      'No painel do aluno, o curso será mostrado em “Cursos atribuídos a você” e não associado a um caminho de aprendizagem.',
    USER_COURSE_DRAWER_CANCEL: 'Cancelar',
    USER_COURSE_DRAWER_ASSIGN: 'Atribuir',
    USER_COURSE_DRAWER_HINT_1: 'Usuários',
    USER_COURSE_DRAWER_HINT_2:
      'Encontre os usuários que você atribuirá a este curso.',
    USER_COURSE_DRAWER_PLACEHOLDER: 'Escreva o nome ou e-mail do usuário',
    USER_COURSE_DRAWER_NOT_FOUND: 'Nenhum usuário encontrado',
    USER_COURSE_DRAWER_DONE_TITLE_1: 'Este curso foi atribuído a',
    USER_COURSE_DRAWER_DONE_TITLE_2: 'usuário(s)',
    USER_COURSE_DRAWER_DONE_SUBTITLE:
      'Você acessará o curso a partir do painel do aluno',
    USER_COURSE_DRAWER_DONE_BUTTON: 'Entendido',

    TABS_SOON_AVAILABLE_TITLE: 'Disponível em breve',

    TABLE_EMPTY_STATE_1: 'Desculpe, nenhum resultado encontrado',
    TABLE_EMPTY_STATE_2: 'Por favor, tente novamente com um termo diferente.',

    TABLE_CONTAINER_SELECTED: 'Selecionado',
    TABLE_CONTAINER_DELETE: 'Excluir',

    GLOBAL_CANCEL: 'Cancelar',
    GLOBAL_CONTINUE: 'Continuar',
    GLOBAL_ACCEPT_CONTINUE: 'Sim, continuar',
    GLOBAL_UNDERSTAND: 'Compreendido',
    GLOBAL_REQUIRED_FIELDS: '* Campos obrigatórios',

    LAST_UPDATE_GENERAL:
      'Última atualização da informação: {{date}} às 00:00 horas.',
    LAST_UPDATE_GENERAL_DESC:
      'Os gráficos mostram apenas as horas de estudo de usuários ativos.',

    REPORT_1_TITLE: 'Relatório geral',
    REPORT_1_DESCRIPTION:
      'Progresso organizacional, detalhes por cursos, desempenho do usuário e atividade da conta',
    REPORT_2_TITLE: 'Usuários da organização',
    REPORT_2_DESCRIPTION:
      'Usuários adicionados à plataforma (ativos e pendentes), incluem atributos e rótulos',
    REPORT_3_TITLE: 'Usuários pendentes',
    REPORT_3_DESCRIPTION:
      'Usuários que não ativaram suas contas Crehana para empresas',
    REPORT_4_TITLE: 'Usuários sem iniciar cursos',
    REPORT_4_DESCRIPTION:
      'Usuários que ativaram suas contas, mas não iniciaram nenhum curso',
    REPORT_5_TITLE: 'Trilhas de aprendizagem gerais',
    REPORT_5_DESCRIPTION:
      'Progresso de todas as trilhas, incluindo detalhes de usuários atribuídos',
    REPORT_6_TITLE: 'Relatório do curso',
    REPORT_6_DESCRIPTION: 'Progresso de seus usuários no curso "{{title}}"',
    REPORT_7_TITLE: 'Relatório de trilha de aprendizagem',
    REPORT_7_DESCRIPTION: 'Progresso de seus usuários na trilha "{{title}}"',
    SEND_REPORT: 'Enviar relatório',
    TITLE_BUTTON_REDIRECT: 'Veja relatórios',

    ROUTEITEM_DETAIL_ROUTES_COURSES: 'cursos',
    ROUTEITEM_DETAIL_ROUTES_REQ: 'Requisitos',
    ROUTEITEM_DETAIL_ROUTES_QUIZES: '{{count}} evaluaciones',
    ROUTEITEM_DETAIL_ROUTES_PROJECT: '1 projeto',
    ROUTEITEM_DETAIL_ROUTES_COURSES_TITLE: 'CURSOS DE TRILHA',

    CARDCOURSE_DETAIL_COURSE_REQUIRED: 'Obrigatório',
    CARDCOURSE_DETAIL_COURSE_PROFESSOR: 'Por {{name}}',
    CARDCOURSE_DETAIL_COURSE_MODULES: '{{count}} módulos',

    MULTISELECT_TABLE_CONTAINER_SELECTED: 'selecionado(s) desta página',
    MULTISELECT_TABLE_CONTAINER_SELECTED_PARTIAL: 'itens selecionados',
    MULTISELECT_TABLE_CONTAINER_SELECTED_ALL:
      'Todos os {{items}} itens foram selecionados',
    MULTISELECT_TABLE_CONTAINER_SELECT_ALL: 'Selecione os {{totalItems}} itens',
    MULTISELECT_TABLE_CONTAINER_DELETE: 'Cancelar a seleção',

    INDUCTION_NESTED_1: 'Resumo',
    INDUCTION_NESTED_2: 'Fluxo de trabalho',
    INDUCTION_NESTED_3: 'Documentos',
    INDUCTION_NESTED_4: 'Acompanhamento',
    INDUCTION_NESTED_5: 'Estágios',

    ROUTES_REPORT_TITLE: 'Prontos! Estamos a preparar o seu relatório',
    ROUTES_REPORT_TITLE_BODY:
      'Dentro de alguns minutos, enviaremos para o seu e-mail o relatório excel com as informações solicitadas. Ele também estará disponível na seção Relatório como parte do histórico de relatórios gerados na plataforma.',
    ROUTES_REPORT_TITLE_BUTTON: 'Compreendido',

    REPORTS_TAB_DIALOG_BUTTON: 'Veja relatórios',

    UPLOAD_DEFAULT_ERROR: 'Oops ocorreu um erro, tente novamente mais tarde',

    HEADER_HELP: 'Ajuda',

    STEP_2_SUBTITLE: 'Verificaremos se está tudo bem com seu arquivo',
    MASSIVE_STEP_1_INPUT_INVALID_FORMAT: 'Formato inválido',
    MASSIVE_STEP_1_INPUT_INVALID_FORMAT_DESC:
      'Certifique-se de que o arquivo esteja em um formato válido, como .xlsx.',
    MENU_ROUTE_CONTENT_4: 'Sessões ao vivo',
    REPORT_8_TITLE: 'Equipes',
    REPORT_8_DESCRIPTION:
      'Status de atividade dos líderes com informações sobre as pessoas responsáveis e links para as estatísticas da equipe.',
    REPORT_9_TITLE: 'Resultado de Aval. como classe',
    REPORT_9_DESCRIPTION:
      'Resumo geral dos resultados de avaliações como classe em todos os cursos.',
    REPORT_10_TITLE: 'Detalhe de Aval. como classe',
    REPORT_10_DESCRIPTION:
      'Detalhe que apresentam todas as perguntas e respostas registradas pelos usuários.',
    REPORT_11_TITLE: 'Relatório de Avaliações e geral',
    REPORT_11_DESCRIPTION:
      'Resultado de avaliações somado a um relatório geral com filtros de usuários ativos',
    NOTIFICATION_TITLE: 'Centro de mensagens para correspondências',
    NOTIFICATION_SUBTITLE:
      'Enviar correspondências para sua equipe e personalizar os detalhes para garantir que todos recebam as informações corretas',
    NOTIFICATION_CTA_SEND: 'Enviar e-mail de teste',
    NOTIFICATION_SEND: 'Enviar',
    NOTIFICATION_LOADING: 'Carregando imagem',
    NOTIFICATION_REEMPLACE: 'Substituir imagem',
    NOTIFICATION_ERROR_LABEL: 'Ocorreu um erro durante o upload',
    NOTIFICATION_RETRY: 'Repetir',
    NOTIFICATION_SUBMIT_PLACEHOLDER: 'Digite o assunto do e-mail',
    NOTIFICATION_SUBMIT_LABEL:
      'Assunto da correspondência ***(*Obrigatório)***',
    NOTIFICATION_SUBMIT:
      'Certifique-se de concluir sua rota antes que o tempo acabe!',
    NOTIFICATION_TEXTAREA_PLACEHOLDER: 'Digite um título',
    NOTIFICATION_ERROR_SIZE: 'Seu arquivo excede o peso máximo',
    NOTIFICATION_PROGRESS_LABEL: 'Upload de imagem',
    NOTIFICATION_ATTACHMENT: 'Carregar anexo',
    NOTIFICATION_ERROR_INPUT: 'Você deve preencher este campo',
    NOTIFICATION_ATTACHMENT_WARNING: '(Max. 3 files, max. weight: 20MB)',
    NOTIFICATION_TOAST_SUCCESS_TITLE: 'O e-mail de teste foi enviado com êxito',
    NOTIFICATION_TOAST_SUCCESS_SUBTITLE:
      'Verifique sua caixa de correio ou mensagens indesejadas',
    NOTIFICATION_TOAST_ERROR_TITLE:
      'Ocorreu um erro ao enviar o e-mail de teste',
    NOTIFICATION_TOAST_ERROR_SUBTITLE: 'Tente novamente mais tarde...',
    NOTIFICATION_TOAST_LOADING_TITLE: 'Estamos enviando o e-mail de teste',
    NOTIFICATION_TOAST_LOADING_SUBTITLE: 'Esta ação pode levar alguns minutos',
    NOTIFICATION_DROP_TEXT:
      'Arraste sua imagem para fazer upload ou *escolha seu arquivo*',
    NOTIFICATION_WARNING:
      'Tamanho: 600 x 192 px, Máximo: 2 MB, Formato: PNG, JPG',
    NOTIFICATION_CTA_PATH: 'Ir para o caminho',

    NOTIFICATION_CUSTOM_TITLE: 'Complete o caminho {{customTitle}}',
    NOTIFICATION_ATTACHMENT_RETRY: 'Tente novamente',
    FILE_SIZE_ERROR: 'O peso do arquivo excede o limite permitido',
    NOTIFICATION_TOAST_SUCCESS_EMAIL_TITLE:
      'O e-mail foi enviado com êxito para os usuários selecionados',
    NOTIFICATION_TOAST_ERROR_EMAIL_TITLE:
      'Ocorreu um erro ao enviar o e-mail para os usuários selecionados',
    NOTIFICATION_TOAST_ERROR_EMAIL_SUBTITLE: 'Tente novamente mais tarde',
    NOTIFICATION_CUSTOM_TOOLTIP:
      'Este e-mail de teste será enviado para o e-mail com o qual você está conectado como administrador',
    NOTIFICATION_ATTACHMENT_HELPER:
      'Formatos permitidos: JPG, JPEG, PNG, GIF, BMP, PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX e ZIP',
    NOTIFICATION_SUBMIT_COURSE:
      'Você tem um curso não concluído; não se esqueça de concluí-lo.',
    NOTIFICATION_SUBMIT_SESSION:
      'Sua sessão ao vivo está prestes a começar - não a perca!',
    NOTIFICATION_CTA_COURSE: 'Ir para o curso',
    NOTIFICATION_CTA_SESSION: 'Veja as próximas sessões',
    NOTIFICATION_CUSTOM_TITLE_COURSE: 'Concluir curso: {{customTitle}}',
    NOTIFICATION_CUSTOM_TITLE_SESSION: 'Faça login na sessão: {{customTitle}}',

    // dropdown filter by tabs
    BACK: 'Voltar',
    DASHBOARD_FILTER_SELECTOR_BUTTON: 'Filtrar por',
    DASHBOARD_FILTER_VIEW_ALL: 'Ver tudo',
    DASHBOARD_FILTER_SELECTOR_TITLE_1: 'Por atributos',
    DASHBOARD_FILTER_SELECTOR_TITLE_ATTR: 'Atributos',
    DASHBOARD_FILTER_SELECTOR_DESC_1:
      'Use critérios para filtrar usuários com base nos atributos com os quais foram marcados.',
    DASHBOARD_FILTER_SELECTOR_TITLE_2: 'Regras de segmentação',
    DASHBOARD_FILTER_SELECTOR_DESC_2:
      'Agrupe usuários com base em diferentes segmentos de dados predefinidos.',
    DASHBOARD_FILTER_SELECTOR_TITLE_3: 'Filtros salvos',
    DASHBOARD_FILTER_SELECTOR_DESC_3:
      'Acesse as visualizações salvas aqui para segmentar informações rapidamente.',
    DASHBOARD_FILTER_SELECTOR_TITLE_4: 'Usuários',
    DASHBOARD_FILTER_SELECTOR_DESC_4:
      'Agrupa usuários com base em diferentes segmentos de dados predefinidos.',
    DASHBOARD_FILTER_SELECTOR_TOOLTIP: 'WIP',
    DASHBOARD_USERS_FILTER_ASC: 'Crescente',
    DASHBOARD_USERS_FILTER_DES: 'Decrescente',
    DASHBOARD_USERS_FILTER_ORDER: 'Ordenar por',
    DASHBOARD_USERS_FILTER_ALPHABETICAL: 'Alfabético',
    DASHBOARD_USERS_FILTER_NUMERIC: 'Numérico',
    DASHBOARD_USERS_FILTER_DATE: 'Data',
    DASHBOARD_FILTERS_ATTRIBUTES_APPLY: 'Aplicar',
    DASHBOARD_FILTERS_ATTRIBUTES_ADD: 'Adicionar',
    DASHBOARD_FILTERS_ATTRIBUTES_ADD_SEGMENT: 'Adicionar um segmento',
    DASHBOARD_FILTERS_ATTRIBUTES_RANGE: 'até',
    DASHBOARD_FILTERS_NOT_DATA_TITLE: 'Você ainda não tem atributos criados',
    DASHBOARD_FILTERS_NOT_DATA_SUBTITLE:
      'Adicione novos atributos aos seus usuários para desbloquear recursos avançados de filtragem.',
    DASHBOARD_FILTERS_NOT_DATA_LINK: 'Criar atributos',
    SAVE_FILTERS: 'Salvar filtros',
    APPLY_FILTERS: 'Aplicar filtros',
    DASHBOARD_FILTERS_ATTRIBUTES_REMOVE: 'Remover filtro',
    DASHBOARD_FILTERS_ATTRIBUTES_EDIT: 'Editar filtro',
    SAVE_FILTERS_NAME_INPUT: 'Digite um nome para seu filtro',
    SAVE_FILTERS_NAME_PLACEHOLDER: 'Espaço para escrever texto',
    SAVE_FILTERS_BUTTON_SAVE: 'Salvar',
    SAVE_FILTERS_BUTTON_CANCEL: 'Cancelar',
    SAVE_FILTERS_ERROR_REQUIRED: 'O campo nome é obrigatório',
    SAVE_FILTERS_ERROR_MESSAGE: 'Ocorreu um erro ao salvar o filtro',
    SAVED_FILTERS_OPTIONS_SELECTED: 'Opções selecionadas',
    SAVED_FILTERS_ERROR_TITLE: 'Houve um erro ao carregar as informações',
    SAVED_FILTERS_ERROR_SUBTITLE:
      'Clique no botão para tentar carregar novamente.',
    SAVED_FILTERS_ERROR_RETRY_BUTTON: 'Tentar novamente',
    UPDATE_FILTERS_ERROR_MESSAGE: 'Ocorreu um erro ao atualizar o filtro',
    SEARCH_FILTER_SAVE: 'Pesquisar filtros salvos',
    SEARCH_FILTER_LABEL:
      'Selecione uma opção de filtro salvo para filtrar informações:',

    NUMERIC_LABEL_PLACEHOLDER: 'Adicionar um segmento',
    NUMERIC_RADIO_1: 'É igual a',
    NUMERIC_RADIO_2: 'Não contém',
    NUMERIC_RADIO_3: 'Intervalo de',
    NUMERIC_RADIO_4: 'Termina com',
    NUMERIC_RADIO_5: 'Começa com',
    NUMERIC_RADIO_6: 'Qualquer valor',
    NUMERIC_RADIO_7: 'Contém',

    ATTRIBUTES_TAGS: 'etiquetas',
    ATTRIBUTES_DELETE: 'Excluir tudo',
    ATTRIBUTES_NOT_FOUND_TITLE: 'Nenhum resultado encontrado para',
    ATTRIBUTES_NOT_FOUND_SUBTITLE: 'Tente novamente com um termo diferente.',
    ATTRIBUTES_PLACEHOLDER_SEARCH: 'Pesquisar atributo do usuário',

    STEP_1_SEGMENTATION_RULES_LIST_DESC_1:
      'Filtrar usuários que correspondam a ',
    STEP_1_SEGMENTATION_RULES_LIST_DESC_2: 'todas',
    STEP_1_SEGMENTATION_RULES_LIST_DESC_3: ' as seguintes condições:',
    STEP_1_SEGMENTATION_RULES_DELETE_ALL: 'Excluir tudo',
    STEP_1_SEGMENTATION_RULES_ITEMS_MAX:
      'Você atingiu o limite máximo de 5 regras.',
    STEP_1_SEGMENTATION_RULES_ITEMS_ADD: 'Adicionar regra',
    LIST_ATTRIBUTES_ITEM_1: 'Alfabético',
    LIST_ATTRIBUTES_ITEM_2: 'Numérico',
    LIST_ATTRIBUTES_ITEM_3: 'Data',
    SEGMENTATION_LABEL_DROPDOWN_1: 'Condicional',
    SEGMENTATION_LABEL_DROPDOWN_2: 'Etiquetas',
    ERROR_CHECK_DC3_TEMPLATES:
      'Ocorreu um erro ao verificar se a organização tem certificados DC3',
    TRACKS_EXPORT_BUTTON_LABEL: 'Baixar Relatório',
  },
};

export default localeViewPt;
